export const configPref = () => {
    return require('../data/qst_pref.json');
}

export const config8im = () => {
    return require('../data/qst_8im.json');
}

export const configEtudes = () => {
    return require('../data/qst_etudes.json');
}